import { Canvas } from '@react-three/fiber'
import { Loader, Center, AccumulativeShadows, RandomizedLight, Environment, OrbitControls, Lightformer } from '@react-three/drei'
import { Model, Logo } from './Lambo'
import { Effects } from './Effects'

export default function App() {
  return (
    <>
      <Canvas flat shadows gl={{ antialias: false }} camera={{ position: [-6, 0, 0], fov: 35 }}>
        <color attach="background" args={['#252526']} />
        <group position={[0, -0.75, 0]}>
          <Center top>
            <Model color="#505090" />
            <Logo />
          </Center>
          <AccumulativeShadows>
            <RandomizedLight position={[2, 5, 5]} />
          </AccumulativeShadows>
          <group position={[1, -0.01, 0]} rotation={[0, Math.PI / 2, 0]}>
            <mesh scale={2.5} position={[2, 0, -1.5]} rotation={[-Math.PI / 2, 0, Math.PI / 2.5]}>
              <ringGeometry args={[0.95, 1, 4, 1]} />
              <meshStandardMaterial color="white" roughness={0.75} />
            </mesh>
            <mesh scale={2.5} position={[-2, 0, -1]} rotation={[-Math.PI / 2, 0, Math.PI / 2.5]}>
              <ringGeometry args={[0.95, 1, 3, 1]} />
              <meshStandardMaterial color="white" roughness={0.75} />
            </mesh>
          </group>
        </group>
        <Environment resolution={1024}>
          <Lightformer position={[-4, 2, 0]} scale={[1000, 1.5, 1]} intensity={1} onUpdate={(self) => self.lookAt(0, 0, 0)} />
          <Lightformer position={[4, 2, 0]} scale={[1000, 1.5, 1]} intensity={1} onUpdate={(self) => self.lookAt(0, 0, 0)} />
          <Lightformer position={[0, 2, 0]} scale={[1000, 2, 1]} intensity={1} onUpdate={(self) => self.lookAt(0, 0, 0)} />
          <Lightformer position={[2, 2, 4]} scale={[1000, 0.1, 1]} color="white" intensity={1} onUpdate={(self) => self.lookAt(0, 0, 0)} />
          <Lightformer position={[2, 2, -4]} scale={[1000, 0.1, 1]} color="white" intensity={1} onUpdate={(self) => self.lookAt(0, 0, 0)} />
        </Environment>
        <Effects />
        <OrbitControls autoRotate enableZoom enablePan={false} makeDefault minPolarAngle={0} maxPolarAngle={Math.PI / 2} />
      </Canvas>
      <Loader />
    </>
  )
}
